package com.milta.core.localization.translations.ro

import com.milta.core.localization.SubscriptionExpiredStrings

internal val SubscriptionExpired = SubscriptionExpiredStrings(
    title = "Abonament expirat",
    driverSoloMessage = "Abonamentul dvs. a expirat. Reînnoiți pentru a continua.",
    patronMessage = "Abonamentul dvs. a expirat. Echipa dvs. nu mai poate accesa Milta.",
    driverUnderPatronMessage = "Abonamentul organizației dvs. a expirat. Contactați organizația pentru a vă restabili accesul.",
    renewButton = "Reînnoiește",
    close = "Închide",
    subscribeButtonTemplate = "Abonați-vă pentru %s",
    driverLinkCodeHint = "Lucrați pentru o companie? Transmiteți-i acest cod: odată asociat, sunteți acoperit de abonamentul ei.",
    checkAccessButton = "Verifică accesul meu",
    accessStillUnavailable = "Acces în continuare indisponibil",
)
